import React from "react";

const APP_NAME = "Sistem Keuangan sekolah";

const Loading = () => {
  return (
    <div className="flex relative w-full h-full min-h-screen bg-teal-500 dark:bg-gray-800 px-2 xl:pr-[20px]">
      <div className="mx-auto my-auto">
        <div className="flex flex-col w-full text-center">
          <div
            style={{ width: `200px`, height: `200px` }}
            className="animate-spin items-center mx-auto"
          >
            <div
              className="h-full w-full border-2 border-t-gray-500
         border-b-gray-700 rounded-[100%]"
            ></div>
          </div>
          <div>
            <p className="text-white pt-8 text-lg font-semibold">{APP_NAME}</p>
            <p className="text-white text-lg font-semibold">Loading...</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
